import React from 'react'
import './About.css'

export default function About() {
    return (
        <>
           <h2>Welcome to the About Page</h2> 
           <div className="container about-page">
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos ea in vitae odio voluptas expedita quaerat minima nihil ullam dolorum qui quo voluptatibus accusantium nulla voluptatum eum laborum beatae saepe non, culpa itaque. Aut minima quisquam sapiente unde libero nulla eligendi fuga? Eligendi facilis consequuntur accusamus deserunt omnis consequatur dolores, dolore ipsam ipsum at recusandae aspernatur possimus sint iure labore. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad architecto inventore nam praesentium omnis vero.</p>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt vero animi hic sequi ab asperiores rerum eligendi cum officiis nisi vel, nulla aut quis pariatur consequatur cumque natus. Eos debitis veniam rerum cupiditate, dolores maiores repudiandae animi earum dolor, explicabo ducimus. Velit, est obcaecati vero explicabo dolorum et voluptates modi dolor excepturi fugit! Nulla pariatur quae suscipit magni soluta voluptatem.</p>
           </div> 
             
        </>
    )
}
